import { validateMonitoringDetailSearch } from "@entities/monitoring/monitoring";
import { MonitoringModel } from "@pages/monitoring-model/monitoring-model";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/monitoring/$modelId/")({
	component: RouteComponent,
	validateSearch: validateMonitoringDetailSearch,
});

function RouteComponent() {
	return <MonitoringModel />;
}
